/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type PayoutSetupStatus = typeof PayoutSetupStatus[keyof typeof PayoutSetupStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutSetupStatus = {
  OrganizationRelationshipNeeded: 'OrganizationRelationshipNeeded',
  NotStarted: 'NotStarted',
  IdentityVerificationPending: 'IdentityVerificationPending',
  PayoutMethodNeeded: 'PayoutMethodNeeded',
  BankAccountAwaitingReview: 'BankAccountAwaitingReview',
  BankAccountRejected: 'BankAccountRejected',
  BankAccountUnlinked: 'BankAccountUnlinked',
  BankAccountReturned: 'BankAccountReturned',
  DebitCardNotPayoutEligible: 'DebitCardNotPayoutEligible',
  DebitCardPayoutsUnavailable: 'DebitCardPayoutsUnavailable',
  Ready: 'Ready',
} as const;
